import { styled } from '@mui/material';
import MuiDialogContent, {
  DialogContentProps,
} from '@mui/material/DialogContent';
import { dialogTitleClasses } from '@mui/material/DialogTitle';

import { mergeSx } from '../../utils';
import Scroller from '../scroller/Scroller';

const SCROLLER_CLASS = 'ScrollableDialogContent-scroller';

const StyledDialogContent = styled(MuiDialogContent)({
  overflow: 'hidden',
  flex: 1,
  minHeight: 0,
  padding: 0,
  [`.${dialogTitleClasses.root} + & > .${SCROLLER_CLASS}`]: {
    paddingTop: 0,
  },
});

/**
 * @deprecated Old dialog system — `DialogV2` from `@cast/design-system` wraps its children
 * with `Scroller` automatically, so this is usually unnecessary. When composing from building
 * blocks, use `Scroller` from `@cast/design-system` directly.
 * To migrate a dialog that uses this, run the `/refactor-dialog <path>` skill.
 */
export const ScrollableDialogContent = ({
  children,
  sx,
  ...props
}: DialogContentProps) => (
  <StyledDialogContent {...props}>
    <Scroller
      className={SCROLLER_CLASS}
      sx={mergeSx({ padding: '20px 24px', height: '100%' }, sx)}
      options={{ overflow: { x: 'visible' } }}
    >
      {children}
    </Scroller>
  </StyledDialogContent>
);
